import * as angular from 'angular';

export class ReportsFactory {
    private apiRoot: string = '/api/v1/companies';
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    getClientsReport(companyId, parameters) {
        return this.$http.get(
            `/api/v1/companies/${companyId}/reports/company_clients/`,
            {
                params: parameters,
                responseType: 'arraybuffer',
            }
        );
    }

    getCompanyEmployeesReport(companyId, parameters) {
        return this.$http.get(
            `/api/v1/companies/${companyId}/reports/company_employees/`,
            {
                params: parameters,
                responseType: 'arraybuffer',
            }
        );
    }
}

angular.module('app').service('ReportsFactory', ReportsFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/reports.factory.ts